import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "Layout";
import useApi from "shared/hooks/api";

import { getCurrentUser, getStoreLocalStorage } from "shared/utils/authToken";

import {
  Box,
  BoxGrid,
  BoxTitle,
  BoxValue,
  Container,
  EditBtn,
  FormGroup,
  FormInput,
  FormInputGroup,
  FormTitle,
  GroupedBtn,
  IconContainer,
  InputLabel,
  ModalBtn,
  PageContent,
  PageHeader,
  PageHeaderButton,
  Pagetitle,
  PlanStatus,
  PlusIcon,
  PriceFormContainer,
  PricingForm,
  SubTitle,
  TableAction,
  TableActions,
  Title,
  ViewAllBtn,
} from "../Styles";
import SharedCheckList from "shared/clientcomponents/SharedCheckList";
import Modal from "shared/quickComponents/modal";
import Spinner from "shared/components/Spinner";
import { pricingOBJ } from "Pricing/pricingClass";
import { EmptyState, GradientLoader, Table } from "shared/components";
import { toast } from "react-toastify";
import { OtpContainer } from "Pricing/Single/Styles";
import OTPInput from "shared/components/OTPInput";
import { numberFormat, numberIntFormat } from "shared/utils/utility";
import DashboardSubHeader from "shared/components/DashboardSubHeader";
import { useEffectOnce } from "shared/hooks/useEffectOnce";
import {
  AuxOtpText,
  OtpBtn,
  OtpBtnContainer,
} from "Auth/pages/ReceiveOtp/Styles";
import SelectField from "Business/AddBusiness/SelectField";
import { Btn, TopBtnsContainer } from "Settlements/Overview/Styles";
import BoxButton from "Pricing/BoxButtons";

const tableHeader: any = [
  { id: "pricingName", label: "Name" },
  { id: "pricingType", label: "Type" },
  { id: "pricingChannel", label: "Channel" },
  { id: "pricingCurrency", label: "Currency" },
  { id: "pricingValue", label: "Value" },
  { id: "flatBenchmark", label: "Benchmark" },
  { id: "cap", label: "Cap" },
  { id: "funcProps", label: "Status" },
];

const agencytableHeader: any = [
  { id: "pricingName", label: "Name" },
  { id: "pricingType", label: "Type" },
  { id: "pricingChannel", label: "Channel" },
  { id: "pricingCurrency", label: "Currency" },
  { id: "pricingValue", label: "Value" },
  { id: "pricingCreated", label: "Created" },
  { id: "pricingUpdated", label: "Updated" },
  { id: "funcProps", label: "Status" },
];

export default function Home() {
  const [btnName, setbtnName] = useState("Gateway");
  const [planData, setplanData] = useState([]);
  const [agencyplanData, setAgencyplanData] = useState([]);
  const [localPlan, setlocalPlan] = useState([]);
  const [intlPlan, setintlPlan] = useState([]);
  const [tempId, settempID] = useState("");

  const [isModalOpen, setisModalOpen] = useState(false);

  const [totalLocal, settotalLocal] = useState(0);
  const [totalIntl, settotalIntl] = useState(0);

  const [isLoading, setisLoading] = useState(true);

  const [isOtpModalOpen, setisOtpModalOpen] = useState(false);
  const [isOTPError, setisOTPError] = useState(false);

  const [action, setaction] = useState("");

  const [searchContent, setSearchContent] = useState<string | undefined>();
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState<any>("");
  const [pinBox, setPinBox] = useState(1);

  const closeModal = () => {
    setisModalOpen(false);
    //setshowActivityIndicator(false);
  };

  //Controlling otp modal
  const openModal = () => {
    setisOtpModalOpen(false);
  };

  const getplans = async () => {
    setisLoading(true);
    try {
      // alert(btnName
      //   .toString()
      //   .replace(" ", "_")
      //   .toUpperCase())
      const response: any = await pricingOBJ.getAllPricing(
        btnName
          .toString()
          .replace(" ", "_")
          .toUpperCase()
      );
      
      // console.log("Pulled Data: ", response);
      setplanData([]);
      if (response.length) {
        await setplanData(response);

        // const inte=response.filter((price: any)=>price.currency !='NGN');
        // settotalIntl(inte.length);
        //const local=planData.filter((data: any)=>data.currency =='NGN');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setisLoading(false);
    }
  };

  //====== Handle OTP ======
  const handleOTP = async (otp: string) => {
    console.log("otp====>", otp);
    // setOtp(otp);
    if (otp.length === 6) {
      console.log("OTP=====>", otp, action, tempId);
      const otpResponse = await pricingOBJ.confirmOTP({
        otp,
        action,
        tempId,
      });
      console.log("confirm otp response ====>", otpResponse);
      if (otpResponse?.status) {
        openModal();
        //toast.success(otpResponse?.message);
        getplans();
      } // else {
      //   toast.error(otpResponse?.message);
      // }
    }
  };

  // //==== Function for edit button
  const handleEdit = (plan: any) => {
    // setpageAction(action);
    // setisModalOpen(true);
    // setpricingName(plan.name);
    // plan.status === "PRIVATE" ? setisPrivate(true) : setisPrivate(false);
    // plan.status === "PUBLIC" ? setisPublic(true) : setisPublic(false);
    // setplanType(plan.type);
    // setpercentageValue(plan.value.percentage);
    // setfixedValue(plan.value.flat);
    // setSelectedPlanID(plan.id);
  };

  //=== This function check and format pricing plan value field
  const displayValue = (priceType: any, priceValue: any) => {
    if (priceType === "PERCENTAGE") return `${priceValue?.percentage}%`;
    if (priceType === "FLAT") {
      if (pinBox == 2) {
        return numberIntFormat(priceValue?.flat);
      } else {
        return numberFormat(priceValue?.flat);
      }
    }
    if (priceType === "DYNAMIC")
      if (pinBox == 2) {
        return `${priceValue.percentage}% + ${numberIntFormat(
          priceValue?.flat
        )}`;
      } else {
        return `${priceValue.percentage}% + ${numberFormat(priceValue?.flat)}`;
      }
  };

  //=== This function create plan list for table

  const reshapeData = async () => {
    const planList: any = planData && planData instanceof Array &&
      (await planData?.map((plan: any, index: number) => {
        if (btnName.toString().replace(" ","").toLocaleLowerCase() == "gateway") {
          return {
            pricingName: plan.name,
            pricingType: plan.valueType,
            pricingChannel: plan.channels,
            pricingCurrency: plan.currency,
            flatBenchmark: plan.defaultValue.flatBenchmark,
            cap: plan.defaultValue.cap,
            pricingValue: displayValue(plan.valueType, plan.defaultValue),
            funcProps: (
              <TableActions>
                <PlanStatus>{plan.status}</PlanStatus>
                <GroupedBtn>
                  {/* pass plan into handleEdit function */}
                  <EditBtn
                    onClick={() => {
                      handleEdit(plan);
                    }}
                  >
                    Edit
                  </EditBtn>
                  <Link to={`/pricing/overview/${plan.id}`}>
                    <ViewAllBtn>View</ViewAllBtn>
                  </Link>
                </GroupedBtn>
              </TableActions>
            ),
          };
        } else if(btnName.toString().replace(" ","").toLocaleLowerCase()=='agencybanking') {
          return {
            pricingName: plan.name,
            pricingType: plan.valueType,
            pricingChannel: plan.channels,
            pricingCurrency: plan.currency,
            pricingCreated: plan.createdAt.split("T")[0],
            pricingUpdated: plan.updatedAt.split("T")[0],
            pricingValue: JSON.stringify(plan.defaultValue),
            funcProps: (
              <TableActions>
                <PlanStatus>{plan.status}</PlanStatus>
                <GroupedBtn>
                  {/* pass plan into handleEdit function */}
                  <EditBtn
                    onClick={() => {
                      handleEdit(plan);
                    }}
                  >
                    Edit
                  </EditBtn>
                </GroupedBtn>
              </TableActions>
            ),
          };
        }else{
          return(
            <>Coming soon!</>
          )
        }
      }));
    setlocalPlan(planList);
  };

  const handleFilter = (searchData: any) => {
    setSearchContent(searchData);
    const newlist = planData.filter((plan: any) => {
      if (
        plan.name
          .toString()
          .toLowerCase()
          .indexOf(searchData.toString().toLowerCase()) > -1
      )
        return plan;
    });
    if (newlist.length) setplanData(newlist);

    if (!searchData) {
      if (pinBox == 2) setplanData(intlPlan && intlPlan);
      // reset data
      else setplanData(localPlan && localPlan);
    }
  };

  // useEffect(() => {
  //   if(pinBox==2){
  //     const ints=planData.filter((data: any)=>data.currency !='NGN');
  //     reshapeData(ints);
  //   }else{
  //     reshapeData(planData);
  //   }

  // }, [pinBox]);

  useEffect(()=>{
    reshapeData();
  }, [planData]);
  
  useEffect(() => {
    getplans();
  }, [btnName]);

  useEffect(() => {
    const app = getStoreLocalStorage("application");
    setbtnName(app || "Gateway");
  }, []);
  return (
    <>
      <Container>
        <TopBtnsContainer width="100%">
          <Btn
            isClicked={btnName === "Gateway" ? true : false}
            onClick={() => {
              setbtnName("Gateway");
            }}
          >
            Gateway
          </Btn>
          <Btn
            isClicked={btnName === "Agency Banking" ? true : false}
            onClick={() => {
              setbtnName("Agency Banking");
            }}
          >
            Agency Banking
          </Btn>
          <Btn
            isClicked={btnName === "PayRev" ? true : false}
            onClick={() => {
              setbtnName("PayRev");
            }}
          >
            PayRev
          </Btn>
          <Btn
            isClicked={btnName === "Salari" ? true : false}
            onClick={() => {
              setbtnName("Salari");
            }}
          >
            Salari
          </Btn>
        </TopBtnsContainer>
        <PageHeader>
          <BoxButton
            application={btnName}
            totalLocal={totalLocal}
            totalIntl={totalIntl}
            setPinBox={setPinBox}
          />
        </PageHeader>
        <PageContent>
          {isLoading ? (
            <GradientLoader />
          ) : (
            <>
              <DashboardSubHeader
                // count={totalBusinesses ? totalBusinesses : 0}
                title={`${btnName} Price`}
                btnTitle=""
                withSearch={true}
                placeholder="Pricing Name"
                withFilter={false}
                widthActionBtn={false}
                filterOptions={["Name", "Date"]}
                setSearchData={handleFilter}
                callBackFn={() => ""}
                searchContent={searchContent}
              />
              <Table
                headData={
                  btnName == "Gateway" ? tableHeader : agencytableHeader
                }
                bodyData={planData ? localPlan : []}
                totalPages={totalPages}
                currentpage={currentPage}
                serialNumber
              />
            </>
          )}
        </PageContent>
      </Container>
    </>
  );
}
